// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"458bc5c6","239":"d6a80d98","453":"d33f51cd","732":"e57f7870"}[chunkId] + ".chunk.js";
};